export default __webpack_public_path__ + "static/media/uganda2.c34e4f2f.jpg";